import * as t from 'io-ts';

import {PageSchema} from '../common/Page';
import {SupplierViewSchema} from './SupplierView';

const optionalPart = t.partial({});
const requiredPart = t.interface({
    content: t.array(SupplierViewSchema),
});

export const SuppliersPageSchema = t.exact(t.intersection([PageSchema.type, optionalPart, requiredPart]));

export interface SuppliersPage extends t.TypeOf<typeof SuppliersPageSchema> {}
